/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_GarageInputs */

const cs_enum_garage = /** @type {(inputs: Enum_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garáž`)
};

const en_enum_garage = /** @type {(inputs: Enum_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage`)
};

/**
* | output |
* | --- |
* | "Garage" |
*
* @param {Enum_GarageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_garage = /** @type {((inputs?: Enum_GarageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_GarageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_garage(inputs)
	return cs_enum_garage(inputs)
});